import type { UnwrapNestedRefs } from "vue";

import { useBrowserLocation, useWindowSize } from "@vueuse/core";
import { computed } from "vue";

import type { ToMaybeRefs } from "@solvari/utils";

import { toOriginPath } from "@solvari/utils";

type BrowserAttributes = ToMaybeRefs<
  UnwrapNestedRefs<ReturnType<typeof getBrowserAttributes>>
>;

function getBrowserAttributes() {
  const browserLocation = useBrowserLocation();

  return {
    screenWidth: useWindowSize().width,
    url: computed(() => toOriginPath(browserLocation.value.href ?? "") ?? ""),
    urlDomain: computed(() => browserLocation.value.host ?? ""),
    urlFull: computed(() => browserLocation.value.href ?? ""),
    urlPath: computed(() => browserLocation.value.pathname ?? ""),
  };
}

export { getBrowserAttributes };
export type { BrowserAttributes };
